import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      user: {},
      loggedIn: false,
    },
    company: {},
    selectedApp: {},
    appsSuite: [],
    isSso: false,
    redirectRoute: "",
  },
  mutations: {
    updateUser(state, data) {
      state.user.user = data.user;
      state.user.loggedIn = data.loggedIn;
    },
    updateCompany(state, data) {
      state.company = data;
    },
    updateSelectedApp(state, data) {
      state.selectedApp = data;
    },
    updateAppsSuite(state, data) {
      state.appsSuite = data;
    },
    updateRedirectRoute(state, data) {
      state.redirectRoute = data;
    },
    updateIsSso(state, data) {
      state.isSso = data;
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    company(state) {
      return state.company;
    },
    selectedApp(state) {
      return state.selectedApp;
    },
    appsSuite(state) {
      return state.appsSuite;
    },
    redirectRoute(state) {
      return state.redirectRoute;
    },
    isSso(state) {
      return state.isSso;
    },
  },
});
